var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_setup.socialNetworks),function(network){return _c(_setup.BtnSocial,_vm._b({key:network.title,attrs:{"title":_vm.$t(network.title)}},'btn-social',network,false),[_c('v-icon',{attrs:{"small":""}},[_vm._v(" "+_vm._s(network.icon)+" ")])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }